import {State} from "./types";

export const initialState: State = {
  stack: [],
  activeModal: undefined,
};
